import { render, staticRenderFns } from "./franchiseekitOrder.vue?vue&type=template&id=38fb415d"
import script from "./franchiseekitOrder.vue?vue&type=script&lang=js"
export * from "./franchiseekitOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports